import {
	EngineCommunicationChannels,
	LoggerAction,
	StorageUploadFileChannel,
} from '@webitel/api-services/gen/models';
import { RingtoneType } from '@webitel/ui-sdk/enums';
import { NotificationType } from '../../../modules/settings/modules/notifications/enums/NotificationType';

export default {
	auth: {
		register: 'Тіркелу',
		login: 'Кіру',
		registerReset: 'Құпия сөзді қалпына келтіру',
		detailsSubtitle: 'Төменде өзіңіздің мәліметтеріңізді енгізіңіз',
		resetPasswordLink: 'Құпия сөзді ұмыттыңыз ба?',
		user: 'Пайдаланушы атауы',
		password: 'Құпия сөз',
		confirmPassword: 'Құпия сөзді қайталаңыз',
		key: 'Лицензиялық кілт',
		registerSubmit: 'Тіркелу',
		resetSubmit: 'Қалпына келтіру',
		loginSubmit: 'Кіру',
		carousel: {
			title1: 'Аудандық vs. Құрылған',
			text1:
				'Қауіпсіздік саясаты мәліметтерді сақтауға және аудандық қызметтерді пайдалануға рұқсат етпейді? Webitel арқылы сіз өзіңіздің құрылған контакті орталығыңызды құрастыра аласыз!',

			title2: 'Көпканалды VS Омниканалды',
			text2:
				'Сіздің клиенттеріңізбен әрдайым және әр жерде байланысқа болатын! IVR-менен қарапайым, шығыс, кіру әрекеттері немесе сәлемдерді социалдық желілерде - енді ол ертеде де қарапайым!',

			title3: 'Қауіпсіз инфраструктура',
			text3:
				'Қауіпсіздік саясаты мәліметтерді сақтауға және аудандық қызметтерді пайдалануға рұқсат етпейді? Webitel арқылы сіз өзіңіздің әрбір минутында 1000 көп клиенттік қоңырауларын өңдеуге болады. Әр түрлі коммуникациялық каналдардан.',

			title4: 'Дизайн',
			text4:
				'Жаңа минималистикалық интерфейс және ең қолданыстары үшін ең қарапайым админ панелі. Сізге барлық қажетті функцияларға тез қол жеткізуге болады. Кіші кілттер - көбірек функциялар.',

			title5: 'Жаңа агент топтық жұмыс модулі',
			text5:
				'Ең тиімді қоңырау таралуы. Агент әр түрлі әрекеттерде қатысуға болатын бірнеше қабілеттерді қабылдай алады. Клиент тек профессионалдармен қызмет көрсетеді.',

			title6: 'Рұқсаттарды басқару',
			text6:
				'Жаңа рұқсаттарды басқару модулі - жаңа бақылау мүмкіндіктері. Қолданушылар әрбір бөлімді өзгертуге және әрекеттерге рұқсат жасауға болады.',
		},
	},

	header: {
		logout: 'Шығу',
		docs: 'Документтер',
	},

	appNavigator: {
		title: 'Webitel қолданбалары',
		admin: 'Админ',
		agent: 'Агент жұмыс орны',
		supervisor: 'Бақылаушы жұмыс орны',
		audit: 'Аудит',
		history: 'Қоңырау тізімі',
		grafana: 'Grafana',
	},

	settings: {
		settings: 'Орнатпа | Орнатпалар',
		changePassword: 'Құпия сөзді өзгерту',
		language: 'Тіл',
		fallbackLanguage: 'Әдепкі тіл',
		webPhone: 'WebPhone',
		useWebPhone: 'WebPhone пайдалану',
		useStun: 'STUN пайдалану',
		notifications: {
			[NotificationType.NewMessageSound]: 'Жаңа хабарлама дыбысы',
			[NotificationType.NewChatSound]: 'Жаңа чат дыбысы',
			[NotificationType.SelfAssignedCallSound]:
				'Өзіне тағайындалған қоңырау дыбысы',
			[NotificationType.ChatEndSound]: 'Чат аяқталған дыбыс',
			[NotificationType.CallEndSound]: 'Қоңырау аяқталған дыбыс',
			[NotificationType.TaskEndSound]: 'Тапсырма аяқталған дыбыс',
			[NotificationType.ChatEndPush]: 'Чат аяқталған push хабарландыру',
			[NotificationType.CallEndPush]: 'Қоңырау аяқталған push хабарландыру',
			[NotificationType.TaskEndPush]: 'Тапсырма аяқталған push хабарландыру',
			[NotificationType.SocketCloseSound]: 'Байланыс үзілген дыбыс',
		},
		ringtones: {
			title: 'Қоңырау рингтонын өзгерту',
			ringtone: 'Қоңырау дыбысы',
			customRingtone: 'Қолданба дыбысын пайдалану',
		},
		ringtoneVolume: {
			title: 'Дыбыс деңгейін баптау',
			[RingtoneType.Call]: 'Қоңырау',
			[RingtoneType.Chat]: 'Чат',
			[RingtoneType.Task]: 'Тапсырма',
		},
		security: {
			security: 'Қауіпсіздік',
			logoutTitle: 'Бұл пайдаланушыны басқа құрылғылардан шығару',
		},
	},

	validation: {
		email: 'Электрондық пошта тәрізді болуы керек',
		required: 'Бұл өріс қажет',
		sameAs: 'Құпия сөз қате',
		gatewayHostValidator: 'IPv4 немесе FQDN тәрізді болуы керек',
		ipValidator: 'IPv4 тәрізді болуы керек',
		macValidator: 'MAC тәрізді болуы керек',
		numeric: 'Сан болуы керек',
		requiredArrayValue: 'Массив бос болмауы керек',
		isPositiveValue: 'Мән оң сан болуы керек',
		cron: 'Крон өрнегі қате',
		hourRange: 'Сағат 00-ден 23-ке дейін болуы керек',
		timerangeStartLessThanEnd:
			'"Бастап" уақыты "Дейін" уақытынан кеш болмауы керек',
		timerangeNotIntersect:
			'Бір күннің уақыт аралықтары бір-бірімен қиыспауы керек',
	},

	nav: {
		directory: {
			directory: 'Директория',
		},
		routing: {
			routing: 'Маршруттау',
		},
		lookups: {
			lookups: 'Құжаттар',
		},
		ccenter: {
			ccenter: 'Контакті орталығы',
		},
		integrations: {
			integrations: 'Интеграциялар',
		},
		permissions: {
			permissions: 'Рұқсаттар',
		},
		system: {
			system: 'Жүйе',
		},
	},

	home: {
		dashboard: 'Бақылау панелі',
		welcomeText: '',
		news: 'Жаңалықтар',
	},

	objects: {
		all: 'Барлық {entity}',
		administration: 'Басқару',
		general: 'Жалпы',
		new: 'Жаңа',
		add: 'Қосу',
		create: 'Құру',
		read: 'Оқу',
		edit: 'Өзгерту',
		delete: 'Өшіру',
		save: 'Сақтау',
		saved: 'Сақталды',
		saveAs: 'Сақтау',
		close: 'Жабу',
		next: 'Келесі',
		back: 'Артқа',
		change: 'Өзгерту',
		name: 'Ат',
		title: 'Тақырып',
		description: 'Сипаттама',
		action: 'Әрекет',
		allow: 'Рұқсат',
		password: 'Құпия сөз',
		history: 'Тарих',
		copy: 'Көшіру',
		copied: 'Көшірілді!',
		createdAt: 'Құрылды',
		createdBy: 'Құрушы',
		online: 'Онлайн',
		offline: 'Офлайн',
		on: 'Іске қосылған',
		off: 'Сөндірілген',
		ok: 'ОК',
		enabled: 'Іске қосылған',
		status: 'Күй',
		from: 'Қайдан',
		to: 'Қашан',
		importJSON: 'JSON импорты',
		addNew: 'Жаңа қосу',
		provider: 'Қолданушы',
		default: 'Баптау',
		service: 'Қызмет',
		tts: 'Мәтінді аудиоға аудару',
		stt: 'Аудиодан мәтінге аудару',
		key: 'Кілт',
		ID: 'ID',
		email: ({ linked }) => linked('vocabulary.emails'),
		updatedAt: 'Өзгертілді',
		emptyWorkspace: 'Енді құжаттар жоқ',
		emptyResultSearch: 'Іздеу сіздің қажетіңізге сәйкес келмеді',

		deleteConfirmation: {
			title: 'Өшіруді растау',
			askingAlert:
				'Сіз {count} элементті өшіруді қалаймыз ба? | Сіз {count} элементті өшіруді қалаймыз ба?',
			undoneActionAlert: 'Бұл әрекет қалпына келтірілмейді.',
			deleteAll: 'БАРЛЫҒЫ',
		},
		generalInfo: 'Жалпы ақпарат',
		objectHeader: {},
		directory: {
			directory: 'Директория',
			passwordInfo:
				'Мәніңізді өзгерту үшін (немесе жаңа құру үшін) бос өрісті қалпына келтіру үшін, бос өрісті қалпына келтіру керек',
			users: {
				users: 'Пайдаланушы | Пайдаланушылар',
				allUsers: 'Барлық пайдаланушылар',
				searchPlaceholder: 'Аты, кіру, кеңейтулер, күй',
				login: 'Кіру',
				extensions: 'Кеңейтулер',
				state: 'Күй',
				DnD: 'DnD',
				status: 'Күй',
				roles: 'Рұқсаттар',
				tokens: 'Токендер',
				usage: 'Пайдалану',
				expiryDays: 'Жарамдылық мерзімі',
				expiryDate: 'Жарамдылық мерзімі',
				roleAdmin: 'Админ',
				license: 'Лицензия',
				devices: 'Құрылғылар',
				defaultDevice: 'Таңдалған құрылғылар тізімінен құрылғы',
				deviceNotFound: 'Құрылғы табылмады ма?',
				createNewDevice: 'Жаңа қосу',
				variables: 'Айнымалылар',
				varKey: 'Кілт',
				varVal: 'Мән',
				token: 'Токен | Токендер',
				tokenPopupHeader: 'Сіздің токен кілті сәтті құрылды!',
				tokenPopupText:
					'Сіздің токен кілтін жүктеу үшін немесе оны көшіріңіз. Егер сіз жаңадан токен кілтін жүктемесеңіз, сіз оны қайта қайтару мүмкін емес боласыз. Қауіпсіздік үшін сіздің токен кілтін қауіпсіз және оны бөлмеңізге сақтаңыз.',
				tokenPopupCopy: 'Көшіріп алу',
				tokenPopupSave: 'TXT сақтау',
				userIp: 'Пайдаланушы IP',
				userId: 'Пайдаланушы ID',
				download: 'Жүктеу',
				regenerate: 'Қайта құру',
				askingAlert:
					'Сіз қайта құруды қалаймыз ба? Пайдаланушы кіру мүмкін емес болады',
				chatName: 'Чат көрсету аты',
				temporaryPassword: 'Уақытша құпия сөз',
				communications: 'Коммуникациялар',
				generateDevice: 'Құрылғыны генерациялау',
				deviceGenerationTitle: 'Құрылғы генерациясы',
				deviceGeneration:
					'Бұл әрекет осы пайдаланушы үшін жаңа құрылғыны автоматты түрде жасайды.',
				deviceWasGenerated: 'Құрылғы жасалды',
				deviceGenerationConfirmTitle: 'Құрылғы генерациясын растау',
				generateDeviceConfirmation:
					'Ағымдағы құрылғылар жасалған құрылғымен ауыстырылады. Жалғастырасыз ба?',
				authorizationSecurity: 'Авторизация және қауіпсіздік',
				mustChangePassword:
					'Пайдаланушы алғашқы кіргенде құпия сөзді өзгертуі керек.',
				extensionsHelperText: 'Ішкі нөмір тек сандардан тұруы тиіс',
				csvMappingFields: {
					login: ({ linked }) => linked('vocabulary.login'),
					name: 'Аты',
					extension: ({ linked }) =>
						linked('objects.directory.users.extensions'),
					email: ({ linked }) => linked('vocabulary.emails'),
				},
				logout: {
					endAllSessions: 'Барлық сессияларды аяқтау',
					endAllMySessions: 'Менің барлық сессияларымды аяқтау',
					endSessionConfirmation: 'Сессияны аяқтауды растау',
					endSessionConfirmationText:
						'Барлық сессияларды аяқтағыңыз келгеніне сенімдісіз бе?',
					endMultipleSessionsConfirmationText:
						'Сіз {count} пайдаланушы үшін барлық сеанстарды аяқтауға сенімдісіз бе?',
					tooltip: 'Пайдаланушы барлық құрылғылардан шығарылады',
				},
			},
			license: {
				customers: 'Клиенттер',
				license: 'Лицензия | Лицензиялар',
				licenseId: 'ID',
				allCustomers: 'Барлық клиенттер',
				allLicenses: 'Барлық лицензиялар',
				serial: 'Серия',
				product: 'Өнім',
				validFrom: 'Дұрыс басталды',
				validTill: 'Дұрыс қашан',
				used: 'Пайдаланылды',
				limit: 'Шектеу',
				status: 'Күй',
				competitive: 'Қарапайым',
				searchPlaceholder: 'Серия, өнім',
				domain: 'Аймақ',
				daysToExpire: {
					0: 'Төмендеді',
					30: '30 немесе одан аз',
					90: '90 немесе одан аз',
					days: ' күн',
				},
				importLicense: 'Лицензия импорты',
				licenseKey: 'Лицензия кілті',
			},
			devices: {
				devices: 'Құрылғы | Құрылғылар',
				newDevice: 'Жаңа құрылғы',
				newDeviceDescription: 'Жаңа құрылғыны сипаттау',
				allDevices: 'Барлық құрылғылар',
				searchPlaceholder:
					'Аты, пайдаланушы, аутентификация ID және жұмыс үстелі ID',
				authId: 'Аутентификация ID',
				presence: 'Қатысу',
				hotdesk: 'Hotdesk құрылғысы',
				hotdeskDevice: 'Hotdesk құрылғысы',
				hotdeskDeviceSettings: 'Hotdesk құрылғысының баптаулары',
				hotdeskIncorrectInput: 'Host Name қате енгізілді',
				hotdeskInputHint:
					'Бұл құрылғыны ерекшелеу үшін оған бірегей hotdesk бүркеншік атын беруіңіз керек. Бүркеншік ат тек әріптерден, 0-9, -, _ таңбаларынан тұруы керек',
				deviceSettings: 'Құрылғы баптаулары',
				hostName: 'Хост атауы',
				phoneInfo: 'Телефон туралы ақпарат',
				phone: 'Телефон',
				vendor: 'Өндіруші',
				model: 'Модель',
				ipv4: 'IPv4',
				mac: 'MAC',
				deviceHistory: 'Құрылғы тарихы',
				loggedIn: 'Кірді',
				loggedOut: 'Шықты',
				state: {
					nonreg: 'Тіркелмеген',
					reged: 'Тіркелген',
					ringing: 'Шалынуда',
					dialing: 'Терілуде',
					dialog: 'Диалог',
					onhold: 'Күту режимінде',
				},
				passwordSetFromAccount:
					'Егер сіз құпия сөзді орнатпасаңыз, ол аккаунттың құпия сөзімен бірдей болады',
				csvMappingFields: {
					account: ({ linked }) => linked('webitelUI.headerActions.account'),
					name: ({ linked }) => linked('reusable.name'),
					password: ({ linked }) => linked('vocabulary.password'),
					vendor: 'Өндіруші',
					model: 'Модель',
					mac: 'MAC мекенжайы',
					ip: 'IP мекенжайы',
				},
			},
		},
		permissions: {
			permissions: 'Рұқсаттар',
			permissionsRole: 'Рұқсат | Рұқсаттар',
			allRoles: 'Барлық рұқсаттар',
			searchPlaceholder: 'рұқсат ..',
			roles: {
				permissions: {
					permissions: 'Рұқсат | Рұқсаттар',
					add: 'Қосу',
					delete: 'Өшіру',
					read: 'Таңдау',
					write: 'Өзгерту',
					eavesdropCall: 'Активті диалогты қарау',
					playbackRecordFile: 'Аудио қоңырау-көрсеткіш файлдарын ойнау',
					timeLimitedRecordFile: 'Уақыттық қоңырау-көрсеткіш файлдарын ойнау',
					resetActiveAttempts: 'Активті сынамалар туралы',
					limitWorkspaceContacts: 'Жұмыс орнындағы контакттар тізімін көру',
					exportDataGrid: 'Массивті файлға экспорттау',
					viewCdrPhoneNumbers: 'CDR телефон нөірлерін көру',
					manageUserRoles: 'Пайдаланушы рұқсаттарын басқару',
					manageUserLicense: 'Пайдаланушы лицензияларын басқару',
					changeUserPassword: 'Пайдаланушы құпия сөзін өзгерту',
					systemSetting: 'Жүйе орнатпаларын басқару',
					addDescription: 'Барлық объекттерді құруға рұқсат',
					deleteDescription: 'Барлық объекттерді өшіруге рұқсат',
					readDescription: 'Барлық объекттерді таңдауға рұқсат',
					writeDescription: 'Барлық объекттерді өзгертуге рұқсат',
					eavesdropCallDescription: 'Активті диалогты қарауға рұқсат',
					playbackRecordFileDescription:
						'Аудио қоңырау-көрсеткіш файлдарын ойнауға рұқсат',
					timeLimitedRecordFileDescription:
						'Уақыттық қоңырау-көрсеткіш файлдарын ойнауға рұқсат',
					resetActiveAttemptsDescription: 'Активті сынамалар туралы рұқсат',
					limitWorkspaceContactsDescription:
						'Жұмыс орнындағы контакттар тізімін көруге рұқсат',
					exportDataGridDescription: 'Массивті файлға экспорттауға рұқсат',
					viewCdrPhoneNumbersDescription: 'CDR телефон нөмірлерін көру',
					manageUserRolesDescription:
						'Пайдаланушы рұқсаттарын басқаруға рұқсат',
					manageUserLicenseDescription:
						'Пайдаланушы лицензияларын басқаруға рұқсат',
					changeUserPasswordDescription:
						'Пайдаланушы құпия сөзін өзгертуге рұқсат',
					systemSettingDescription: 'Жүйе орнатпаларын басқаруға рұқсат',
					schemeVariables: 'Жалпы айнымалыларды басқару',
					controlAgentScreen: 'Агент экранын басқару',
					schemeVariablesDescription:
						'Жалпы айнымалылар бөлімін басқаруға рұқсат',
				},
				addPermission: 'Рұқсат қосу',
				usage: 'Пайдалану',
				applicationsAccess: {
					applicationsAccess: 'Қолданбаларға рұқсат | Қолданбаларға рұқсат',
					access: 'Рұқсат',
				},
			},
			object: {
				object: 'Объекттер',
				allObjects: 'Барлық объекттер',
				ObAC: 'Операциялармен басқарылады',
				RbAC: 'Көрсеткіштермен басқарылады',
				operations: 'Операциялар',
				searchPlaceholder: 'объект ..',
				newPermissionRole: 'Қолданушы',
				rbacDefault: 'Негізгі көрсеткіштік рұқсат',
				grantor: 'Құрушы',
				grantee: 'Қолданушы',
				create: 'Құру',
				delete: 'Өшіру',
				accessMode: {
					1: 'Құтылу',
					2: 'Рұқсат',
					3: 'Рұқсатты делегирлеу',
				},
			},
		},
		lookups: {
			lookups: 'Құжаттар',
			skills: {
				skills: 'Қабілет | Қабілеттер',
				capacity: 'Қабілет',
				minCapacity: 'Ең аз қабілет',
				minCapacityLessOrEqualToMaxCapacityValidator:
					'Ең аз қабілет ең көп қабілеттен аз немесе тең болуы керек',
				maxCapacity: 'Ең көп қабілет',
				maxCapacityMoreOrEqualToMinCapacityValidator:
					'Ең көп қабілет ең аз қабілеттен артық немесе тең болуы керек',
				lvl: 'Деңгей',
				agentSkills: 'Агент қабілеттері | Агент қабілеттері',
				allSkills: 'Барлық қабілеттер',
				state: 'Күй',
				stateForAll: 'Барлық үшін күй',
				changeSkillTo: 'Қабілетті өзгерту',
				changeAgentsSkill: 'Агенттің қабілетін өзгерту',
				totalAgents: 'Барлық агенттер',
				activeSkillAgents: 'Активті қабілет агенттері',
				assignSkillToAgents: 'Қабілетті агенттерге беріңіз',
				assignAgent: 'Агентті беріңіз',
				selectCapacityAndState: 'Қабілет пен күйді таңдаңыз',
			},
			buckets: {
				buckets: 'Бакет | Бакеттер',
				allBuckets: 'Барлық бакеттер',
				addBucket: 'Бакет қосу',
			},
			blacklist: {
				blacklist: 'Тізім | Тізімдер',
				allBlacklists: 'Барлық тізімдер',
				number: 'Нөмір | Нөмірлер',
				newNumber: 'Жаңа нөмір',
				numbersCount: 'Нөмірлер',
				expireAt: 'Төмендеді',
				temporary: 'Уақытша',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
					description: ({ linked }) => linked('vocabulary.description'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
				},
				importResult:
					'Импортталған нөмірлер: {imported}. Өткізіп жіберілген қайталанулар: {skipped}.',
			},
			media: {
				mediaFiles: 'Медиа файл | Медиа файлдар',
				allMediaFiles: 'Барлық медиа файлдары',
				createdAt: 'Құрылды',
				format: 'Формат',
				size: 'Өлшем',
				textToSpeech: 'Мәтінді аудиоға аудару',
				popupSettings: 'Орнатпалар',
				lang: 'Тіл',
				voice: 'Дыбыс',
				token: 'Токен',
				key: 'Кілт',
				dragPlaceholder: 'Файлдарды тартып-қойыңыз',
				dragPlaceholderHere: 'мұнда.',
				tts: {
					hint: 'Аудио файлын құру',
					textType: {
						textType: 'Мәтін түрі',
						ssml: 'SSML',
					},
				},
			},
			regions: {
				regions: 'Орналасу | Орналасулар',
				allRegions: 'Барлық орналасулар',
			},
			timezone: {
				timezone: 'Уақыт аймағы | Уақыт аймақтары',
			},
			calendars: {
				calendars: 'Календарь | Календарьлер',
				allCalendars: 'Барлық календарьдер',
				searchPlaceholder: 'Аты, сипаттама...',
				timezone: 'Уақыт аймағы',
				start: 'Бастау',
				end: 'Аяқтау',
				workWeek: 'Жұмыс аптасы',
				specialTime: 'Арнайы уақыт',
				holidays: 'День | Күндер',
				date: 'Күн',
				repeat: 'Қайталау',
				fulltime: 'Уақытша',
				everyYear: 'Әр жылға қайталау',
				newHoliday: 'Жаңа мереке',
				mon: 'Дүйсенбі',
				tue: 'Сейсенбі',
				wed: 'Сәрсенбі',
				thu: 'Бейсенбі',
				fri: 'Жұма',
				sat: 'Сенбі',
				sun: 'Жексенбі',
				workingTime: 'Жұмыс уақыты',
				workStart: 'Жұмыс уақыты бастау',
				workStop: 'Жұмыс уақыты аяқтау',
			},
			communications: {
				communications: 'Коммуникация түрі | Коммуникация түрлері',
				allCommunications: 'Барлық коммуникация түрлері',
				addCommunication: 'Коммуникация қосу',
				missingCommunication: 'Коммуникация түрін қосыңыз',
				code: 'Код',
				channels: {
					[EngineCommunicationChannels.Phone]: 'Телефон',
					[EngineCommunicationChannels.Email]: 'Пошта',
					[EngineCommunicationChannels.Messaging]: 'Хабарлама',
				},
			},
			pauseCause: {
				pauseCause: 'Пауза себептері',
				allPauseCause: 'Барлық агент демалыс себептері',
				limit: 'Шектеу (мин)',
				min: 'мин',
				allowAdmin: 'Админ демалыс күйін өзгертуге рұқсат',
				allowSupervisor: 'Бақылаушы демалыс күйін өзгертуге рұқсат',
				allowAgent: 'Агент демалыс күйін өзгертуге рұқсат',
			},
			quickReplies: {
				quickReplies: 'Тез жауап | Тез жауаптар',
			},
			activityTypes: {
				activityTypes: 'Әрекет түрі | Әрекет түрлері',
			},
		},
		routing: {
			routing: 'Маршруттау',
			ip: 'IP',
			protocol: 'Протокол',
			port: 'Порт',
			configuration: 'Орнатпа',
			schema: 'Өткізу схемасы',
			json: 'JSON',

			flow: {
				flow: 'Өткізу схемасы | Өткізу схемалары',
				allFlowSchemas: 'Барлық өткізу схемалары',
				createFlowSelectionPopup: 'Жаңа өткізу құру',
				createNew: 'Жаңа құру ма?',
				editor: 'Редактор',
				diagram: {
					diagram: 'Диаграмма',
					description:
						'Webitel Flow Diagram инструментін пайдаланып жаңа өткізуді құру',
				},
				code: {
					code: 'Код',
					description:
						'Код редакторында JSON-схемасын пайдаланып жаңа өткізуді құру',
				},
				askingAlert: 'Сіз өзгерткен өзгерістерді "{name}" құруға қалаймыз ба?',
			},

			dialplan: {
				dialplan: 'Дайындық сандары',
				dialplanRules: 'Дайындық ережелері',
				pattern: 'Мақсатты нөмір',
				dialplanRule: 'Дайындық ережесі',
				position: 'Орын',
				allowTransfer: 'Ауыстыруға рұқсат беру',
			},

			chatplan: {
				chatplan: 'Чат сандары | Чат сандары',
				allChatplans: 'Барлық чат сандары',
			},

			gateways: {
				gateways: 'Қабылдаушы | Қабылдаушылар',
				allGateways: 'Барлық қабылдаушылар',
				trunkingGateway: 'Транкинг қабылдаушы',
				registerGateway: 'Тіркеу қабылдаушы',
				stateSuccess: 'Сәтті',
				stateFailed: 'Ақау',
				stateProgress: 'Жүргізілген',
				stateNonreg: 'Тіркелмеген',
				proxy: 'Прокси',
				searchPlaceholder: 'қабылдаушы іздеу...',
				host: 'Қабылдаушы',
				trunkingACL: 'Транкинг кіру бақылауы тізімі',
				hostnameTrunking: 'Сервер/Қабылдаушы атауы немесе IP',
				hostnameRegister: 'Тіркеуші/Сервер/Қабылдаушы атауы немесе IP',
				expire: 'Төмендеді',
				authID: 'Пайдаланушы атауы',
				account: 'Аккаунт',
				outboundProxy: 'Шығыс прокси атауы немесе IP',
				newGateway: 'Жаңа қабылдаушы',
				newGatewayDescription: 'Жаңа қабылдаушы сипаттамасы',
				SIPregistrations: 'SIP Тіркеу',
				SIPregistrationsDescription: 'SIP тіркеу сипаттамасы',
				SIPtrunking: 'SIP транкинг',
				SIPtrunkingDescription: 'SIP транкинг сипаттамасы',
			},
			chatGateways: {
				templates: {
					templates: 'Шаблон | Шаблондар',
					title: 'Жұмыс орны мүшесінің аты',
					close: 'Чат толық хабарламасы',
					join: 'Агент қосылу хабарламасы',
					left: 'Агент айырылу хабарламасы',
					filePolicyFail: 'Тыйым салынған файл форматы',
				},
				chatGateways: 'Чат қабылдаушы | Чат қабылдаушылар',
				allChatGateways: 'Барлық чат қабылдаушылар',
				telegramBot: {
					telegramBot: 'Telegram Бот',
				},
				telegramApp: {
					telegramApp: 'Telegram Қолданбасы',
					signedAs: 'Сіз тіркелгенсіз',
					joinTelegram: 'Telegramға кіру',
					signOut: 'Telegramнан шығу',
					metadata: {
						apiId: 'API id',
						apiHash: 'API hash',
					},
				},
				infobip: {
					infobip: 'Infobip',
				},
				messenger: {
					meta: 'Мета',
					addOrRemovePages: 'Беректерді қосу немесе өшіру',
					accounts: 'Аккаунттар',
					metadata: {
						clientId: 'App ID',
						clientSecret: 'App Secret',
						apiVersion: 'API нұсқасы',
						apiVersionHint: 'Формат: vXX.X (мысалы, v24.0)',
					},
					facebook: {
						pages: 'Facebook беректері',
						subscription: 'Webhook подписка',
					},
					instagram: {
						instagram: 'Instagram',
						comments: 'Комментарийлерді талдау',
						mentions: 'Меншіктемелерді талдау',
					},
					whatsapp: {
						whatsapp: 'Whatsapp',
						token: 'Токен',
						status: 'Күй',
						number: 'Телефон нөмірі',
						review: 'Бағалау',
					},
				},
				viber: {
					viber: 'Viber',
					style: {
						style: 'Стиль',
						btnBackColor: 'Батырма түсі',
						btnFontColor: 'Батырма шрифті түсі',
					},
				},
				webchat: {
					webchat: 'Web чат',
					copyCode: 'Сайтқа код көшіру',
					copyCodeHint:
						'Widget орнатпаларын өзгерту әрбір ретте Widget кодын сайтқа көшіру керек',
					metadata: {
						mediaMaxSize: 'Максимальды медиа өлшемі (МБ)',
					},
					view: {
						view: 'Көру',
						borderRadius: 'Батырма түрі',
						language: 'Тіл',
						position: 'Орын',
						btnColor: 'Батырма түсі',
						logoUrl: 'Лого URL',
						logoHint: "Лого түрі 'JPEG' немесе 'PNG', 24x24px",
						rounded: 'Дөңгелек',
						square: 'Төбе',
						right: 'Оң',
						left: 'Сол',
					},
					recaptcha: {
						recaptcha: 'reCAPTCHA',
						sitekey: 'Сайт кілті',
						secret: 'Құпия кілт',
						threshold: 'Шектеу',
						showFlag: 'reCAPTCHA белгісін көрсету',
					},
					chat: {
						chat: 'Чат',
						openTimeout: 'Ашылу таймақ',
						openTimeoutSec: 'Ашылу таймақ (сек)',
					},
					appointment: {
						appointment: 'Болжам',
						days: 'Күндер',
						availableAgents: 'Қолжетімді агенттер',
						showEmailField: 'Электрондық пошта өрісін көрсету',
						showMessageField: 'Хабарлама өрісін көрсету',
						resultPageText: 'Нәтиже беті мәтіні',
						headingText: 'Бас тақырып',
						subheadingText: 'Алдын ала тақырып',
						showDefaultHeading:
							'Нәтиже бетіндегі бас тақырып пен алдын ала тақырыпты көрсету',
					},
					alternativeChannels: {
						alternativeChannels: 'Альтернативті каналдар',
						title: 'Хабарлама каналдары',
						email: 'Пошта',
						whatsapp: 'WhatsApp',
						telegram: 'Telegram',
						messenger: 'Messenger',
					},
					call: {
						title: 'Онлайн қоңырау',
						url: 'WebSocket нөмірі',
					},
				},
				customChat: {
					customChat: 'Қолданбасы',
					customChatGateway: 'Қолданбасы қабылдаушы',
					appSecretHint: 'Бұл өрісті өзгерту интеграцияны бұзып қалдырады',
					metadata: {
						appSecret: 'App Secret',
						callback: 'Каллбек',
					},
				},
				uri: 'URI',
				newChatGateway: 'Жаңа чат қабылдаушы',
				metadata: {
					apiKey: 'Api Кілті',
					baseUrl: 'Негізгі URL',
					allowOrigin: 'Қолданушылар',
					readTimeout: 'Оқу таймақ (сек)',
					writeTimeout: 'Жазу таймақ (сек)',
					handshakeTimeout: 'Қол алмау таймақ (сек)',
					botName: 'Бот аты',
					telegramToken: 'Telegram BOT API Токен',
				},
			},

			callflow: {
				callflow: 'Көрсеткіш',
			},
		},

		ccenter: {
			ccenter: 'Контакті орталығы',

			agents: {
				agents: 'Агент | Агенттер',
				supervisors: 'Бақылаушы | Бақылаушылар',
				admins: 'Админ | Админдер',
				subordinates: 'Басқа агент | Басқа агенттер',
				allAgents: 'Барлық агенттер',
				chatCount: 'Чат саны',
				taskCount: 'Тапсырма саны',
				progressiveCountValidator:
					'Мән 1-ден үлкен болуы немесе бос болуы керек',
				extraChatCount: 'Қосымша чаттар саны',
				state: 'Күй',
				isSupervisor: 'Бақылаушы',
				stateTime: 'Күй уақыты',
				statusType: 'Күй түрі',
				addSkill: 'Қабілет қосу',
				editSkill: 'Қабілетті өзгерту',
				statusHistory: 'Күй тізімі',
				historyState: 'Күй',
				payload: 'Себеп',
				addSubordinate: 'Басқа агентті қосу',
				historyChannel: 'Канал',
				historyFrom: 'Қайдан',
				historyTo: 'Қашан',
				historyDuration: 'Ұзақтығы',
				emptyPopup: 'Фильтрлерді тексеріңіз',
				status: {
					online: 'Онлайн',
					offline: 'Офлайн',
					pause: 'Демалыс',
					breakOut: 'Шығу',
				},
				wfm: 'WFM',
				workingConditions: 'Жұмыс шарттары',
				pauseTemplate: 'Демалыс шаблоны',
				agentScreenControl: 'Агент экранын басқару',
				agentScreenControlHint:
					'Топ параметрі қосылған кезде өшіру мүмкін емес',
			},

			auditors: {
				auditors: 'Аудитор | Аудиторлар',
			},

			teams: {
				teams: 'Команда | Командалар',
				allTeams: 'Барлық командалар',
				strategy: 'Стратегия',
				parameters: 'Параметрлер',
				maxNoAnswer: 'Максимальды әрекеттер саны',
				callTimeout: 'Қоңырау қабылдау таймақ',
				inviteChatTimeout: 'Чат қабылдау таймақ',
				wrapUpTime: 'Қорытындылау уақыты',
				noAnswerDelayTime: 'Әрекет жоқ болғаннан кейін кешігу уақыты',
				taskAcceptTimeout: 'Тапсырма қабылдау таймақ',
				strategies: {
					random: 'Тәуелсіз',
					fewestCalls: 'Ең аз қоңырау алатын агент',
					leastTalkTime: 'Ең аз сөйлесу уақыты алатын агент',
					topDown: 'Жоғарыдан төмен',
					roundRobin: 'Айналмалы',
					roundRobinBucket: 'Айналмалы бакет',
					longestIdleAgent: 'Ең ұзақ уақыт бойы қалған агент',
					skillCapacity: 'Қабілет деңгейі бойынша',
				},
				hooks: {
					eventTypes: {
						agentStatus: 'Агент күйі өзгерді',
					},
				},
				flows: {
					addFlowSchema: 'Өткізу схемасын қосу',
					editFlowSchema: 'Өткізу схемасын өзгерту',
				},
				supervisors: {
					addSupervisor: 'Бақылаушын қосу',
					editSupervisor: 'Бақылаушын өзгерту',
				},
				agents: {
					addAgent: 'Агентті қосу',
					editAgent: 'Агентті өзгерту',
				},
			},

			members: {
				members: 'Меншік | Меншіктер',
				allMembers: 'Барлық меншіктер',
				addMember: 'Меншікті қосу',
				destination: 'Мақсат',
				communications: 'Коммуникациялар',
				display: 'Көрсету нөмірі',
				dtmf: 'DTMF',
				priority: ({ linked }) => linked('objects.memberPriority'),
				attempts: 'Сынамалар',
				emptyWorkspace: 'Меншіктер табылмады',
				resetMembers: {
					resetMembers: 'Меншіктерді қалпына келтіру',
					description: {
						all: 'Күнді шектеместен сәтсіз әрекеттерді қалпына келтіргіңіз келетініне сенімдісіз бе?',
						filtered:
							'Сіз \n{dateFrom} мен {dateTo} аралығындағы\nсәтсіз әрекеттерді қолданылған сүзгілер мен іздеу нәтижелері бойынша қалпына келтіргіңіз келетініне сенімдісіз бе?',
						selected:
							'Сіз сәтсіз әрекеттерді қалпына келтіргіңіз келетініне сенімдісіз бе?',
					},
					descriptionCount: '{count} жазба әсер етеді.',
					emptyDescription:
						'Ағымдағы сүзгілер бойынша сәтсіз әрекеттер табылған жоқ. Қалпына келтіретін ешнәрсе жоқ.',
					reset: 'Қалпына келтіру',
					successResetCount: 'Сәтті {count} меншіктерді қалпына келтірді',
				},
				exportMembers: {
					exportMembers: 'Мүшелерді экспорттау',
				},
				endCause: {
					abandoned: ({ linked }) => linked('objects.stopCause.abandoned'),
					timeout: ({ linked }) => linked('objects.stopCause.timeout'),
					cancel: ({ linked }) => linked('objects.stopCause.cancel'),
					success: ({ linked }) => linked('objects.stopCause.success'),
					failed: ({ linked }) => linked('objects.stopCause.failed'),
					missed: ({ linked }) => linked('objects.stopCause.missed'),
					expired: ({ linked }) => linked('objects.stopCause.expired'),
					canceledByTimeout: ({ linked }) =>
						linked('objects.stopCause.canceledByTimeout'),
				},
				csvMappingFields: {
					name: 'Атауы',
					timezoneId: ({ linked }) => linked('date.timezone'),
					priority: ({ linked }) => linked('vocabulary.priority'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
					bucketId: 'Бакет',
					agentId: ({ linked }) => linked('objects.agent.agent'),
					variables: ({ linked }) => linked('vocabulary.variables'),
					destination: ({ linked }) => linked('vocabulary.destination'),
					commPriority: 'Байланыс түрлерінің басымдығы',
					code: 'Код',
					description: ({ linked }) => linked('vocabulary.description'),
					dtmf: 'DTMF',
				},
			},

			globalStateConfirmation: {
				title: 'Өзгерістерді қолдану',
				message: 'Өзгерістер {count} жазбаға қолданылады. Сіз сенімдісіз бе?',
			},

			queues: {
				queues: 'Қойма | Қоймалар',
				allQueues: 'Барлық қоймалар',
				type: 'Түрі',
				state: 'Күй',
				active: 'Активті',
				notActive: 'Активті емес',
				activeCalls: 'Активті қоңыраулар',
				waiting: 'Күту',
				ringtone: 'Қоңырау',
				priority: 'Приоритет',
				teams: 'Команда | Командалар',
				tags: 'Тақтар',
				newQueue: 'Жаңа қойма',
				saveBeforeAddingRecords:
					'Жазбаларды қоспас бұрын кезектің міндетті өрістерін толтырыңыз',
				blacklist: 'Стоп тізімі',
				resources: ({ linked }) => linked('objects.ccenter.res.res'),
				resourceGroups: ({ linked }) =>
					linked('objects.ccenter.resGroups.resGroups'),
				newQueueDescription: 'Жаңа қойма сипаттамасы',
				outboundIVRQueue: 'Шығыс IVR қоймасы',
				outboundIVR: 'Шығыс IVR',
				outboundIVRQueueDescription:
					'Шығыс IVR көп каналдардың көмегімен өзіздің ұйымыңыздың көп клиенттерін автоматты түрде қатысуға мүмкіндік береді. Автоматты аудио қоңыраулар, SMS хабарламалар, электрондық пошта немесе персоналдық хабарламалар пайдалану арқылы.',
				inboundQueue: 'Кіру қоймасы',
				inboundQueueDescription:
					'Кіру қоймасы - бұл қоңыраулар қолданушыларын қолданушыға берілген қоймада орналасқан қойма.',
				offlineQueue: 'Офлайн қойма',
				offlineQueueDescription:
					'Офлайн қойма - қолданушылар қолданушыға берілген қоймада орналасқан қоймадан тыс тұрып, телефон нөмірін енгізіп, ол қатарына келгенде қол қойып алу мүмкіндігін береді.',
				previewDialer: 'Превью дайындық',
				previewDialerDescription:
					'Автоматты дайындықта қоңырауларға дейін қоңыраушының қалайын көрсету',
				progressiveDialer: 'Прогрессивті дайындық',
				progressiveDialerDescription:
					'Прогрессивті дайындық қоңыраулар арасындағы уақытты үнемдеуге көмектеседі, өйткені қоңыраушы қоңырау тізімінен санын автоматты түрде қоңырауға мүмкіндік береді.',
				predictiveDialer: 'Прогнозды дайындық',
				predictiveDialerDescription:
					'Прогнозды дайындық бір уақытта көп сандарды қоңырауға мүмкіндік береді. Қолданушы жауап бергенде, агент оларға қосылады.',
				chatInboundQueue: 'Чат кіру қоймасы',
				chatInboundQueueDescription: 'Кіру қоймасымен бірдей, бірақ чаттармен',
				imChatQueue: 'IM чат қоймасы',
				imChatQueueDescription:
					'Чат қоймасымен бірдей, бірақ мессенджерлер үшін',
				inboundJobQueue: 'Кіру тапсырмасы қоймасы',
				inboundJobQueueDescription: 'Кіру тапсырмасы қоймасы',
				outboundJobQueue: 'Шығыс тапсырмасы қоймасы',
				outboundJobQueueDescription: 'Шығыс тапсырмасы қоймасы',
				strategy: 'Стратегия',
				timezone: 'Уақыт аймағы',
				callLimit: 'Қоңырау шектеуі',
				variables: 'Айнымалылар',
				members: 'Меншік | Меншіктер',
				params: 'Параметрлер',
				discardAbandonedAfter: 'Абандондалғаннан кейін қою',
				maxIdleAgent: 'Агент жауап таймақ',
				maxIdleClient: 'Клиент жауап таймақ',
				maxIdleDialog: 'Максимальды жауап таймақ',
				timeoutWithNoAgents: 'Таймақсыз агенттер',
				timeBaseScore: 'Уақыттық бағалау',
				endless: 'Аяқсыз',
				stickyAgent: 'Тұрақты агент',
				stickyAgentSec: 'Тұрақты агент (сек)',
				autoAnswerTone: 'Автоматты жауап күлік',
				varKey: 'Кілт',
				varVal: 'Мән',
				endCause: ({ linked }) => linked('objects.stopCause.stopCause'),
				offeringAt: 'Қосу уақыты',
				destination: 'Мақсат | Мақсаттар',
				expire: 'Төмендеді',
				originateTimeout: 'Орнату таймақ',
				maxAgentLine: 'Максимальды агент сызықтар',
				maxAgentLose: 'Максимальды агент жоғалған қоңыраулар',
				minAttempts: 'Ең аз прогноз сынамалары',
				maxAbandonedRate: 'Ең көп абандондалған %',
				loadFactor: 'Жүктеу коэффициенті',
				abandonRateAdjustment: 'Абандондалған % өзгерту',
				playbackSilence: 'Ойнату қараңғылық',
				targetAbandonedRate: 'Мақсат абандондалған %',
				maxWaitTime: 'Максимальды күту уақыты',
				maxWaitingSize: 'Максимальды күту саны',
				waitBetweenRetries: 'Күту аралығында күту',
				waitBetweenRetriesDesc: 'Күтушілерді кему ретімен күту',
				strictCircuit: 'Теріс құрылғы',
				retryAbandoned: 'Абандондалған қайтару',
				playbackFile: 'Ойнату файлы',
				timeout: 'Таймақ',
				maxNumberOfRetry: 'Максимальды қайтару саны',
				minDuration: 'Ең аз қоңырау уақыты',
				maxAttempts: 'Ең көп сынамалар',
				minOnlineAgents: 'Тұрақты онлайн агенттер санынан көп болуы керек',
				waitForResultStatus: 'Нәтиже күйін күту',
				bucketPriority: 'Приоритет',
				amd: 'AMD',
				enabled: 'AMD пайдалану',
				ai: 'Ақпараттық технология',
				positiveLabels: 'Оң белгілер',
				aiPlayback: 'Ойнату файлы',
				allowNotSure: 'Агентке NOTSURE ауыстыру',
				silenceNotSure: 'Агентке қараңғылық ауыстыру',
				allowGreetingAgent: 'Агент келісімділікке рұқсат',
				preSchema: 'Алдын ала құрылғы схемасы',
				afterSchema: 'Кейін құрылғы схемасы',
				maxCalls: 'Ең көп тапсырмалар',
				dialingRate: 'Дайындық ставкасы',
				maxCallsHint: 'Мән 0 болса, тапсырмалар жүргізілмейді',
				recordings: 'Көрсеткіш',
				recordAll: 'Жауаптан кейін көрсеткіш',
				perNumbers: 'Әрбір телефон нөмірі үшін дайындық сынамалары',
				maxWordLength: 'Ең ұзын сөз ұзындығы (мс)',
				maxNumberOfWords: 'Ең көп сөз саны',
				betweenWordsSilence: 'Сөздер арасындағы қараңғылық (мс)',
				minWordLength: 'Ең аз сөз ұзындығы (мс)',
				totalAnalysisTime: 'Жалпы талдау уақыты (мс)',
				silenceThreshold: 'Қараңғылық шектеуі (мс)',
				afterGreetingSilence: 'Келісімділіктен кейінгі қараңғылық (мс)',
				greeting: 'Келісімділік (мс)',
				initialSilence: 'Бастапқы қараңғылық (мс)',
				statisticTime: 'Қайта есептеу аралығы',
				communications: 'Коммуникация түрі',
				manualDistribution: 'Өзіндік таралу',
				lastMessageTimeout: 'Соңғы хабарламадан кейінгі таймақ',
				stickyIgnoreStatus: 'Агент күйін қамту',
				ignoreCalendar: 'Календарьді қамту',
				resourceStrategy: {
					resourceStrategy: 'Қор ресурсы стратегиясы',
					priorityBased: 'Приоритеттік',
					evenDistribution: 'Тең таралу',
				},
				attemptsReset: {
					resetActiveAttempts: ({ linked }) =>
						linked('objects.permissions.roles.permissions.resetActiveAttempts'),
					title: 'Сынамалар қалпына келтіру',
					attemptType: 'Сынама түрі',
					idleTime: 'Қалған уақыт (мин)',
					result: ({ linked }) =>
						linked('objects.integrations.triggers.logs.result'),
					calls: 'Қоңыраулар',
					attemptsCount: 'Сынамалар',
				},
				processing: {
					processing: 'Өңдеу',
					enabled: 'Қоңырау нәтижесін күту',
					formSchema: 'Динамикалық құрылғы схемасы',
					sec: 'Пост-өңдеу уақыты (сек)',
					renewalSec: 'Қалған (сек) болғанда пост-өңдеуді ұзартуды ұсыну',
					allowProlongation: 'Пост-өңдеуді ұзартуға рұқсат ету',
					autosave: 'Өңдеуді автосақтауға рұқсат ету',
					repeatsNumber: 'Қайталаулар саны',
					prolongationTimeSec: 'Ұзарту уақыты (сек)',
					isTimeoutRetry: 'Уақыт бітуге дейін қайталау',
				},
				queueStrategy: {
					fifo: 'FIFO (Бірінші кіріп, бірінші шығу)',
					lifo: 'LIFO (Соңынан кіріп, бірінші шығу)',
					strict_fifo: 'Теріс FIFO (Бірінші кіріп, бірінші шығу)',
				},
				logs: {
					logs: 'Лог | Логтар',
					destination: 'Мақсат',
					offeringAt: 'Қосу',
					joinedAt: 'Бастау',
					leavingAt: 'Аяқтау',
					duration: ({ linked }) => linked('vocabulary.duration'),
					viewNumber: 'Көрсету нөмірі',
					result: ({ linked }) => linked('objects.callReportingResult.result'),
					attempts: 'Сынама',
					resultName: {
						abandoned: ({ linked }) =>
							linked('objects.callReportingResult.abandoned'),
						cancel: ({ linked }) =>
							linked('objects.callReportingResult.cancel'),
						success: ({ linked }) =>
							linked('objects.callReportingResult.success'),
						failed: ({ linked }) =>
							linked('objects.callReportingResult.failed'),
						missed: ({ linked }) =>
							linked('objects.callReportingResult.missed'),
						timeout: ({ linked }) =>
							linked('objects.callReportingResult.timeout'),
						endless: ({ linked }) =>
							linked('objects.callReportingResult.endless'),
						transferred: ({ linked }) =>
							linked('objects.callReportingResult.transferred'),
						shutdown: ({ linked }) =>
							linked('objects.callReportingResult.shutdown'),
					},
				},
				hooks: {
					hooks: 'Құтылым | Құтылымдар',
					event: 'Оқиға',
					eventTypes: {
						joined: 'Қосылды',
						answered: 'Жауап берді',
						offering: 'Қосу',
						bridged: 'Байланыстырылды',
						missed: 'Жоқ',
						leaving: 'Айырылды',
						processing: 'Өңдеу',
						active: 'Активті',
					},
				},
				skills: {
					editSkill: 'Қабілетті өзгерту',
					addSkill: 'Қабілет қосу',
				},
				buckets: {
					addBucket: 'Бакет қосу',
					editBucket: 'Бакетті өзгерту',
				},
			},

			res: {
				res: 'Қор | Қорлар',
				allRes: 'Барлық қорлар',
				reserve: 'Бөлісу',
				searchPlaceholder: 'аты, қабылдаушы..',
				cps: 'CPS',
				limit: 'Шектеу',
				cidType: 'CID түрі',
				ignoreEarlyMedia: 'Ескертулік медиаларды қамту',
				numbers: 'Нөмір | Нөмірлер',
				displayNumbers: 'Көрсету нөмірлері',
				failure: 'Ақау',
				maxErrors: 'Максимальды ақау жауаптары',
				errorCodes: 'Ақау жауаптары',
				patterns: 'Мақсатты нөмір үлгісі',
				priority: 'Приоритет',
				reserveResource: 'Қорды бөлісу',
				failureDialDelay: 'Ақау дайындық кешігу',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
				},
			},

			resGroups: {
				resGroups: 'Қор топтары | Қор топтары',
				allResGroups: 'Барлық қор топтары',
				searchPlaceholder: 'қор топ аты..',
				addResGroup: 'Қор топын қосу',
				editResGroup: 'Қор топын өзгерту',
				strategy: 'Стратегия',
				timerange: 'Уақыт аралығы',
				timerangeFrom: 'Қайдан',
				timerangeTo: 'Қашан',
			},
		},

		integrations: {
			integrations: 'Интеграциялар',
			emptyWorkspace: 'Енді профилдер жоқ',

			storage: {
				storage: 'Қор',
				allStorages: 'Барлық қорлар',
				type: 'Түрі',
				maxSize: 'Қор кеңістігі (ГБ)',
				expireDays: 'Мүмкіндік (күн)',
				priority: 'Приоритет',
				newStorage: 'Жаңа қор',
				newStorageDescription: 'Жаңа қор сипаттамасы',
				local: 'Локальді',
				s3: 'S3 бак',
				digitalOcean: 'Digital Ocean Spaces',
				backblaze: 'Backblaze B2',
				dropbox: 'Dropbox',
				drive: 'Google Drive',
				configuration: 'Орнатпа',
				pathPattern: 'Жол үлгісі',
				localFolder: 'Локальді папка',
				s3Key: 'Кілт ID',
				s3Access: 'Кілт',
				bucket: 'Бак',
				region: 'Аймақ',
				oceanKey: 'Кілт ID',
				oceanAccess: 'Кілт',
				backblazeAccount: 'Аккаунт ID',
				backblazeKey: 'Қолданба кілті',
				backblazeBucketId: 'Бак ID',
				dropboxKey: 'Кіріс токен',
				driveFolder: 'Папка аты',
				driveEmail: 'Google Email',
				driveKey: 'Құпия кілт',
				s3Endpoint: 'Аймақ',
			},

			storagePolicies: {
				storagePolicies: 'Қор саясаты | Қор саясаттары',
				mimeTypes: 'MIME түрлері',
				retentionDays: 'Сақтау күндері',
				maxDownloadSpeed: 'Ең жоғары жүктеу жылдамдығы (кб/с)',
				maxUploadSpeed: 'Ең жоғары жазу жылдамдығы (кб/с)',
				maxUploadSize: 'Ең жоғары жазу өлшемі (байт)',
				applyToFiles: 'Өткен файлдарға сақтау мерзімін қолдану',
				applyPopupMessage:
					'Саясаттың жаңа уақыты өткен файлдарға саясаттың орындалуына әкеледі. Сіз қалаймыз ба?',
				channels: {
					[StorageUploadFileChannel.CallChannel]: 'қоңырау',
					[StorageUploadFileChannel.ChatChannel]: 'чат',
					[StorageUploadFileChannel.MediaChannel]: 'медиа',
					[StorageUploadFileChannel.MailChannel]: 'пошта',
					[StorageUploadFileChannel.LogChannel]: 'лог',
					[StorageUploadFileChannel.ScreenRecordingChannel]: 'экранды жазу',
				},
				encryptFile: 'Жаңа файлдарды шифрлеу',
				encryptFileHint:
					'Шифрлеу кілті жоғалса, файлдарды шифрдан шығара алмайсыз! Жазбалар тек интерфейс немесе API арқылы қолжетімді.',
				encryptionAlertTitle: 'Шифрлеу туралы ескерту',
				encryptionEnableMessage: 'Тек жаңа файлдар шифрланады.',
				encryptionDisableMessage:
					'Ескі файлдар шифрланған күйінде қалады.\nЖаңа файлдар шифрланбайды.',
			},

			cognitiveProfiles: {
				cognitiveProfiles: 'Ақпараттық профиль | Ақпараттық профильдер',
				properties: {
					region: 'Аймақ',
					locale: 'Локализация',
				},
			},
			emailProfiles: {
				emailProfiles: 'Пошта профилі | Пошта профильдері',
				mailbox: 'Поштақа',
				smtpPort: 'SMTP Порт',
				imapPort: 'IMAP Порт',
				smtpHost: 'SMTP Хост',
				imapHost: 'IMAP Хост',
				fetchInterval: 'Жаңарту интервалы',
				listen: 'Тыңдау',
				authType: 'Авторизация түрі',
				authenticatedAs: 'Авторизацияланған',
			},
			singleSignOn: {
				singleSignOn: 'SSO профилі | SSO профильдері',
				provider: 'Провайдер',
				clientId: 'Application (client) ID',
				clientSecret: 'Client secret',
				discoveryUrl: 'Discovery URL',
				scopes: 'Рұқсаттар',
				scopesPlaceholder: 'Рұқсатты енгізіп Enter басыңыз',
				inspect: 'Inspect',
				inspectHint: 'Провайдерге сұраныс жіберіп, токен алу',
				token: 'Токен',
				showToken: 'Токенді көрсету',
				inspectDescription: 'Провайдерге сұраныс жіберіп, токен алу',
				mapping: 'Маппинг',
				mappingKeyHint:
					'Пайдаланушы атрибутын енгізіңіз (мыс., email, username, extension).',
			},

			importCsv: {
				importCsv: 'Файлдан CSV импорты | Файлдан CSV импорты',
				allImportsCsv: 'Барлық CSV файлдардан импорт мәліметтер',
				source: 'Импорт мақсаты',
				settings: 'Орнатпалар',
				mappings: 'Өріс атындарын кірістіктерге сәйкестендіру',
				mappingsHint:
					'Бұл бөлімде сіз кірістіктерге кірістіктердің атындарын кірістіктерге сәйкестендіру керек',
				columnHeader: '{name} бағаны',
				members: {
					clearMembers: 'Бар меншіктерді тазарту',
				},
			},

			tokens: {
				tokens: 'Токен | Токендер',
				allTokens: 'Барлық токендер',
				expires: 'Төмендеді',
				popupMessage:
					'Сіздің токен кілтін жүктеу үшін немесе оны көшіріңіз. Егер сіз жаңадан токен кілтін жүктемесеңіз, сіз оны қайта қайтару мүмкін емес боласыз. Қауіпсіздік үшін сіздің токен кілтін қауіпсіз және оны бөлмеңізге сақтаңыз.',
				tokenCreated: 'Сіздің токеніңіз сәтті құрылды!',
			},

			triggers: {
				triggers: 'Құтылым | Құтылымдар',
				allTriggers: 'Барлық құтылымдар',
				type: 'Түрі',
				schema: 'Схема',
				newTrigger: 'Жаңа құтылым',
				newTriggerDescription:
					'Қарап жатыр немесе бос қағазды құру арқылы бастаңыз, немесе бос қағазды құру арқылы бастаңыз',
				event: 'Оқиға',
				onEventDescription: 'Оқиға негізделген JSON схемасы жоспары',
				cron: 'Уақыт бойы',
				atTimeDescription: 'Уақыт негізделген JSON схемасы жоспары',
				eventSelect: ({ linked }) =>
					linked('objects.ccenter.queues.hooks.event'),
				cases: 'Кейінірек',
				caseFiles: 'Кейінірек файлдары',
				caseComments: 'Кейінірек комментарийлер',
				caseLinks: 'Кейінірек байланыстар',
				call: 'Қоңырау',
				relatedCases: 'Байланыстырылған кейініректер',
				expression: 'Өрнек',
				timeout: 'Таймақ',
				resolutionTime: ({ linked }) => linked('cases.resolutionTime'),
				logs: {
					logs: 'Жүргізілген тізім',
					startedAt: 'Бастау',
					result: 'Нәтиже',
				},
				recordCall: 'Қоңырауды жазу',
				runTrigger: 'Триггерді іске қосу',
			},
		},
		system: {
			system: 'Жүйе',
			changelogs: {
				changelogs: 'Өзгеріс журналы | Өзгеріс журналдары',
				objects: 'Объект | Объекттер',
				daysToStore: 'Сақтау күндері',
				storage: 'Жүктеу',
				logs: {
					logs: 'Лог | Логтар',
					actions: 'Амал | Амалдар',
					records: 'Жазба ID | Жазбалар ID',
					actionType: {
						[LoggerAction.Create]: 'Құру',
						[LoggerAction.Delete]: 'Өшіру',
						[LoggerAction.Update]: 'Өзгерту',
					},
				},
				period: {
					period: 'Период',
					options: {
						daily: 'Күнікі',
						weekly: 'Аптасына',
						fortnightly: 'Аптасына',
						monthly: 'Айда',
					},
				},
			},
			configuration: {
				configuration: 'Орнатпа | Орнатпалар',
				parameter: 'Параметр',
			},
			globalVariables: {
				globalVariables: 'Жалпы айнымалылар | Жалпы айнымалылар',
				encrypted: 'Шифрленген',
				valueInfo: 'Өзгерту үшін мәнді енгізіңіз',
				newTitle: 'Жаңа жалпы айнымалы',
				editTitle: 'Жалпы айнымалыны өзгерту',
			},
		},

		pagination: {
			rowsPerPage: 'Бір беттеңіз',
		},
	},

	filters: {
		team: 'Команда',
		queueType: 'Қойма түрі',
	},

	webitelUI: {
		filters: {
			tags: ({ linked }) => linked('vocabulary.tag'),
			joinedAt: ({ linked }) => linked('objects.joinedAt'),
			result: ({ linked }) => linked('objects.callReportingResult.result'),
			duration: ({ linked }) => linked('vocabulary.duration'),
		},
	},

	utils: {
		downloadFilesBtn: {
			downloadFiles: 'Файлдарды жүктеу',
			filesLoaded: 'Файлдар жүктелді',
			zippingProgress: 'Zipтеу прогресс',
		},
	},

	errorPages: {
		goToHome: 'Бастапқы бетке оралу',
		page403: {
			title: 'Қолжетімділікке рұқсат етілмеді',
			text: 'Кешіріңіз, бұл бетті көру үшін сізде жеткіліксіз рұқсаттар бар.',
		},
		page404: {
			title: 'Сіз қалаған бетті таба алмадыңыз',
			text: 'Кешіріңіз, біз сіздің қалаған бетіңізді таба алмаймыз.',
		},
	},

	icon: {
		docs: 'Документтер',
		logout: 'Шығу',
		account: 'Аккаунт',
		appNavigator: 'Қолданба навигаторы',
		settings: 'Орнатпа',
	},

	iconHints: {
		upload: 'Жүктеу',
		reload: 'Жаңарту кестесі',
		edit: 'Өзгерту',
		delete: 'Өшіру',
		deleteAll: 'Барлық элементтерді өшіру',
		deleteSelected: 'Өшіру {count} таңдалған элементтер',
		deleteFiltered: 'Фильтрлеуден кейінгі барлық элементтерді өшіру',
		resetAll: 'Барлық меншіктерді қалпына келтіру',
		resetSelected:
			'Таңдалған {count} меншікті қалпына келтіру | Таңдалған {count} меншікті қалпына келтіру',
		resetFiltered: 'Фильтрленген барлық меншіктерді қалпына келтіру',
		generate: 'Құру',
		add: 'Қосу',
		history: 'Тарих',
		download: 'Жүктеу',
		downloadAll: 'Барлық жүктеу',
		draggable: 'Тартылатын',
		play: 'Ойнау',
		pause: 'Тоқтату',
		resume: 'Қалпына келтіру',
		close: 'Жабу',
		change: 'Өзгерту',
		volume: 'Дыбыс',
		stop: 'Тоқтату',
		members: 'Меншіктер',
		moveUp: 'Жоғары қозғау',
		moveDown: 'Төмен қозғау',
		nextPage: 'Келесі бет',
		prevPage: 'Алдыңғы бет',
		expand: 'Ұлғаю',
		collapse: 'Қысу',
	},
	errors: {
		invalidJson: 'JSON қате',
	},
	reusable: {
		time: {
			t15m: '15 мин',
			t30m: '30 мин',
			t45m: '45 мин',
			t1h: '1 сағат',
			t3h: '4 сағат',
			t6h: '6 сағат',
		},
	},
};
